<template>
    <ValidationProvider
        rules="max:10000"
        v-slot="{ errors }"
    >
        <v-textarea
            v-model="paragraphText"
            :label="name"
            outlined
            :error-messages="errors"
            @change="emitFieldData"
        />
    </ValidationProvider>
</template>

<script>
import { EventBus } from '@/store/eventBus';
import InputBoilerplate from '@/views/Common/Input/InputBoilerplate';

export default {
    mixins: [ InputBoilerplate ],

    data() {
        return {
            paragraphText: '',
        };
    },

    methods: {
        loadFieldData() {
            this.paragraphText = this.inputData;
        },

        emitFieldData() {
            EventBus.$emit(`${this.namespace}UpdateFieldData`, {
                paragraphText: this.paragraphText,
            });
        }
    }
};
</script>
